<template>
  <div>
    <b-button @click="newgame()">Nouveau jeu</b-button>
    <b-table striped hover :items="games" :fields="fields" 
      @row-clicked="updategame">
      <template slot="date" slot-scope="data">
        {{ data.value | moment("L") }}
        {{ data.value | moment("LT") }}
      </template>
      <template slot="borrower" slot-scope="data">
        <div @click.stop="">
          <b-form-select @change="updateBorrower(data, $event)"
            v-model="data.item.borrower"
            :options="users"
            class="mb-3"
            value-field="email"
            text-field="fullname"
          ></b-form-select>
        </div>
      </template>
    </b-table>
    
    <b-modal v-model="show" id="gameModal" title="Créer/modifier un jeu">
      <b-form @submit="onSubmit" >
        <b-form-group
          label="Nom :"
          label-for="nom">
          <b-form-input 
            id="nom"
            type="text"
            v-model="game.name"
            required />
        </b-form-group>
        <b-form-group
          label="Règles youtube (code de la vidéo) :"
          label-for="youtube_rules">
          <b-form-input 
            id="youtube_rules"
            type="text"
            v-model="game.youtube_rules_url"/>
        </b-form-group>
        <b-form-group
          label="Règles PDF :"
          label-for="text_rules">
          <b-form-input 
            id="text_rules"
            type="text"
            v-model="game.text_rules_url"/>
        </b-form-group>
        <b-form-group
          label="Description :"
          label-for="desc">
          <Editor id="desc" api-key="tinyMceKey" :init="tinySettings" v-model="game.description" />
        </b-form-group>
        <b-form-group
          label="Avis :"
          label-for="view">
          <Editor id="view" api-key="tinyMceKey" :init="tinySettings" v-model="game.view" />
        </b-form-group>
        <div v-if="game.iconUrl">
          <label>Icone</label><br>
          <img :src="backendUrl+'/'+game.iconUrl" width="64"/>
        </div>
        <b-form-group
          label="Nouvelle icone :"
          label-for="view"> 
          <b-form-file
            v-model="game.iconData"
            accept="image/*"
            placeholder="Choisissez une icone..."></b-form-file>
        </b-form-group>
        <b-form-group
          label="Images :"
          label-for="view"> 
          <div v-for="imgUrl in game.imagesUrl"  :key="imgUrl">
            <img :src="backendUrl+'/'+imgUrl" width="64"/>      
            <b-button type="button" @click="addImageForDeletion(imgUrl)" variant="primary">X</b-button>    
          </div>
          <div v-for="img in imgToAdd"  :key="img.name">
            {{ img.name }}
            <b-button type="button" @click="imgToAdd.splice(imgToAdd.indexOf(img), 1)" variant="primary">X</b-button>    
          </div>
          <b-form-file
            v-model="newImage"
            accept="image/*"
            placeholder="Choisissez une icone..."></b-form-file>
            <b-button type="button" @click="addImageForUpload()" variant="primary">Ajouter</b-button>    
        </b-form-group>
        
        <b-button class="login-submit" type="submit" variant="primary">Créer/modifier</b-button>
        <b-button class="login-submit" type="button" v-if="game.id" variant="error" @click="deletegame">Supprimer</b-button>
      </b-form>
      <div slot="modal-footer">
      </div>
    </b-modal>
    
    <b-modal v-model="okModal" title="Sauvegardé">
      <div>
        Jeu sauvegardé
      </div>
    </b-modal>
    <b-modal v-model="okDeleteModal" title="Supprimé">
      <div>
        Jeu supprimé
      </div>
    </b-modal>
    <b-modal v-model="errorModal" title="Oups !!!">
      <div>
        Une erreur est survenue
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Editor from '@tinymce/tinymce-vue'
export default {
  name: 'AdminJeux',
  components:{
    Editor,
  },
  data: function(){
    return {
      games: [],
      game: {},
      users: [],
      newImage: null,
      imgToAdd: [],
      newTag: "",
      show: false,
      okModal: false,
      errorModal: false,
      okDeleteModal: false,
      fields: ['id', 'name', 'borrower'],
      tinyMceKey: 'xwshhuj8lp9xyapn1ubr70gvij35nbk20dnqn5vv4shn834k',
      tinySettings: { 
        menubar: false,
      },
      backendUrl: Vue.$backend.getBackendUrl(),
    }
  },
  created: function(){
    this.reloadList();
    Vue.$backend.listUsers().then(res => {
      for(const user of res){
        user.fullname = user.nom + ' ' + user.prenom
      }
      res.unshift({
        email: null,
        fullname: '',
      })
      this.users = res
    })
  },
  methods: {
    newgame() {
      this.game = {
          youtube_rules_url: "",
          text_rules_url: "",
          description: "",
          view: "",
          rules: "",
          iconUrl: "",
          imagesUrl: [],
      }
      this.imgToAdd = []
      this.show = true
      tinymce.init({seletor:'textarea'})
    },
    updategame(game){
      this.imgToAdd = []
      this.game = game
      this.show = true
    },
    deletegame(){
      Vue.$backend.deleteGame(this.game.id).then(() => {
        this.show = false
        this.okDeleteModal = true
        this.reloadList()
      }, () => {
        this.errorModal = true
      })    
    },
    reloadList() {
      return Vue.$backend.listGames().then(res => {
        this.games = res
        return res
      })
    },
    addImageForDeletion(imgUrl) {
      this.game.imagesUrl.splice(this.game.imagesUrl.indexOf(imgUrl), 1)
      if(!this.game.imgToDelete){
        this.game.imgToDelete = []
      }
      this.game.imgToDelete.push(imgUrl)
    },
    addImageForUpload() {
      this.imgToAdd.push(this.newImage)
    },
    onSubmit(evt) {
      if(evt){
        evt.preventDefault()
      }
      
      const game = {
        "description": this.game.description,
        "name": this.game.name,
        "rules": this.game.rules,
        "text_rules_url": this.game.text_rules_url,
        "view": this.game.view,
        "youtube_rules_url": this.game.youtube_rules_url,
        "borrower": this.game.borrower,
      }

      let gamePromise
      
      if(this.game.id){
        game.id = this.game.id
        gamePromise = Vue.$backend.updateGame(game)
      } else {
        gamePromise = Vue.$backend.createGame(game)
      }
      
      gamePromise
      .then(() => {
        const proms = [];
        if(this.game.iconData){
          proms.push(Vue.$backend.setGameIcon(this.game.imgName, this.game.iconData))
        }
        for(const image of this.imgToAdd){
          proms.push(Vue.$backend.addGameImage(this.game.name, image))
        }
        if(this.game.imgToDelete){
          for(const image of this.game.imgToDelete){
            proms.push(Vue.$backend.deleteGameImage(this.game.name, image))
          }
        }
        return Promise.all(proms)
      })
      .then(() => {
        delete this.game.iconData
        this.show = false
        this.okModal = true
        return this.reloadList()
      })
      .catch((err) => {
        this.errorModal = true
      })
    },
    updateBorrower(data, value){
      data.item.borrower = value
      this.game = data.item
      this.onSubmit()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.inline-50 {
  width:50%;
  display: inline-block;
}

.inline {
  display: inline-block;
}

</style>
